import React, { useState, useRef } from 'react';
import aiHand from './assets/ai-lp.png';
import 'country-flag-icons/react/3x2';
import { GB, TH, MM, LA } from 'country-flag-icons/react/3x2';

// Translation data for the entire page
const translations = {
  en: {
    exchangeRateTitle: 'Exchange Rate System',
    exchangeRateDescription: 'Real-time currency exchange rates and conversion tools for businesses and travelers.',
    tosTitle: 'Terminal Operations System (TOS)',
    tosDescription: 'a business-layer platform for planning, scheduling, resource allocation, credentials, and logistics orchestration, integrated with ERP; interfacing with the Terminal Operation System (TOS) for execution at loading bays.',
    flightRoutePlanningTitle: 'Flight Route Planning',
    flightRoutePlanningDescription: 'Plan and optimize flight paths with 3D Maps, smart routing, weather awareness, and fuel-efficient legs.',
    socialSkylineTitle: 'Social Skyline',
    socialSkylineDescription: 'A social flight game with 3D Maps—fly anywhere you want and chat with friends in the sky in real time.',
    posSystemTitle: 'POS System',
    posSystemDescription: 'Modern Point of Sale system for seamless retail and restaurant operations.',
    companyName: 'TechMaster Solutions Co., Ltd.',
    heroTitle: 'Artificial Intelligence',
    heroDescription: 'Customized software solutions enhanced by powerful AI integration We specialize in developing software tailored to your business needs, integrating AI to simplify workflows, improve accuracy, and optimize long-term efficiency. ',
    readMore: 'Read more',
    about: 'About',
    store: 'Store',
    products: 'Products',
    manuals: 'Manuals',
    company: 'Company',
    signUp: 'Sign up',
    aboutTitle: 'About TechMaster Solutions',
    aboutContent: 'TechMaster Solutions Co., Ltd. is a leading technology company dedicated to delivering innovative and reliable solutions. Established in 2023, our mission is to empower businesses with advanced technology, fostering growth and efficiency in the digital era. We specialize in AI, cloud services, and custom software development.',
    productTitle: 'Our Innovative Products',
    productContent: 'We offer a suite of cutting-edge products designed to meet diverse business needs. Our flagship AI platform, "CognitoAI," provides intelligent automation and data analytics. Additionally, we have "CloudConnect," a secure and scalable cloud infrastructure service, and "InsightFlow," a powerful business intelligence tool.',
    trackingTitle: 'Recycling System',
    trackingDescription: 'End-to-end recycling management for collection, sorting, processing, and sustainability reporting.',
    membershipTitle: 'Cooperative Management System',
    membershipDescription: 'Enterprise-grade cooperative and organizational membership platform covering member records, benefits administration, engagement tracking, and governance operations.',
    aiRecruiterTitle: 'MapRan',
    aiRecruiterDescription: 'Free nationwide branch map for shops and organizations. View locations across the country on MapRan.com with support for every language.',
    announcementTitle: 'Buying and Selling Announcement',
    announcementDescription: 'A platform for buying and selling ads for houses for rent/sale, land for sale/rent, in a simple way.',
    companyTitle: 'Our Vision & Values',
    companyContent: 'At TechMaster Solutions, our vision is to be a global leader in technological innovation, driving positive change for businesses worldwide. We are committed to excellence, integrity, and customer satisfaction. Our core values include innovation, collaboration, and continuous learning, ensuring we always stay ahead in the rapidly evolving tech landscape.',
  },
  th: {
    exchangeRateTitle: 'ระบบอัตราแลกเปลี่ยน',
    exchangeRateDescription: 'ข้อมูลอัตราแลกเปลี่ยนสกุลเงินแบบเรียลไทม์และเครื่องมือแปลงค่าสำหรับธุรกิจและนักเดินทาง',
    tosTitle: 'ระบบปฏิบัติการเทอร์มินัล (TOS)',
    tosDescription: 'แพลตฟอร์มระดับธุรกิจสำหรับการวางแผน การจัดตารางเวลา การจัดสรรทรัพยากร การรับรอง และการจัดการโลจิสติกส์ ผสานรวมกับ ERP เชื่อมต่อกับระบบปฎิบัติการเทอร์มินัล (TOS) เพื่อดำเนินการที่จุดขนถ่ายสินค้า',
    flightRoutePlanningTitle: 'Flight Route Planning',
    flightRoutePlanningDescription: 'วางแผนและปรับเส้นทางบินด้วย 3D Maps อย่างชาญฉลาด พิจารณาสภาพอากาศ และลดการใช้เชื้อเพลิงในแต่ละช่วงบิน',
    socialSkylineTitle: 'Social Skyline',
    socialSkylineDescription: 'เกมบินแบบ Social พร้อม 3D Maps บินไปที่ไหนก็ได้ที่อยากไป และคุยกับเพื่อนๆ บนฟ้าแบบเรียลไทม์',
    posSystemTitle: 'ระบบ POS',
    posSystemDescription: 'ระบบจุดขายสมัยใหม่สำหรับร้านค้าและร้านอาหาร',
    companyName: 'บริษัท เทคมาสเตอร์ โซลูชั่น จำกัด',
    heroTitle: 'ปัญญาประดิษฐ์',
    heroDescription: 'พัฒนาและปรับแต่งซอฟต์แวร์เพื่อธุรกิจของคุณ พร้อมยกระดับประสิทธิภาพด้วยเทคโนโลยี AI เราเชี่ยวชาญในการสร้างระบบซอฟต์แวร์ที่ตอบโจทย์ธุรกิจ พร้อมผสาน AI เพื่อช่วยให้การทำงานง่ายขึ้น แม่นยำยิ่งขึ้น และลดต้นทุนในระยะยาว',
    readMore: 'อ่านเพิ่มเติม',
    about: 'เกี่ยวกับเรา',
    store: 'ร้านค้า',
    products: 'สินค้า',
    manuals: 'คู่มือ',
    company: 'บริษัท',
    signUp: 'ลงทะเบียน',
    aboutTitle: 'เกี่ยวกับ บริษัท เทคมาสเตอร์ โซลูชั่น จำกัด',
    aboutContent: 'บริษัท เทคมาสเตอร์ โซลูชั่น จำกัด เป็นบริษัทเทคโนโลยีชั้นนำที่มุ่งมั่นในการนำเสนอโซลูชั่นที่เป็นนวัตกรรมและเชื่อถือได้ ก่อตั้งขึ้นในปี 2566 พันธกิจของเราคือการเสริมสร้างศักยภาพธุรกิจด้วยเทคโนโลยีขั้นสูง เพื่อส่งเสริมการเติบโตและประสิทธิภาพในยุคดิจิทัล เราเชี่ยวชาญด้าน AI, บริการคลาวด์ และการพัฒนาซอฟต์แวร์แบบกำหนดเอง',
    productTitle: 'ผลิตภัณฑ์นวัตกรรมของเรา',
    productContent: 'เรานำเสนอชุดผลิตภัณฑ์ล้ำสมัยที่ออกแบบมาเพื่อตอบสนองความต้องการทางธุรกิจที่หลากหลาย แพลตฟอร์ม AI หลักของเรา "CognitoAI" ให้ระบบอัตโนมัติอัจฉริยะและการวิเคราะห์ข้อมูล นอกจากนี้ เรายังมี "CloudConnect" ซึ่งเป็นบริการโครงสร้างพื้นฐานคลาวด์ที่ปลอดภัยและปรับขนาดได้ และ "InsightFlow" ซึ่งเป็นเครื่องมือวิเคราะห์ธุรกิจที่มีประสิทธิภาพ',
    trackingTitle: 'ระบบรีไซเคิล',
    trackingDescription: 'ระบบบริหารจัดการรีไซเคิลครบวงจร ครอบคลุมการเก็บรวบรวม คัดแยก แปรรูป และรายงานผลด้านความยั่งยืน',
    membershipTitle: 'ระบบบริหารจัดการสหกรณ์',
    membershipDescription: 'แพลตฟอร์มบริหารสมาชิกสหกรณ์และองค์กรระดับมืออาชีพ ครอบคลุมทะเบียนสมาชิก การจัดการสิทธิประโยชน์ การติดตามการมีส่วนร่วม และกระบวนการกำกับดูแล',
    aiRecruiterTitle: 'MapRan',
    aiRecruiterDescription: 'ดูสาขาร้านค้าและองค์กรบนแผนที่ทั่วประเทศได้ฟรี ผ่าน MapRan.com พร้อมรองรับทุกภาษา',
    announcementTitle: 'ประกาศซื้อขาย',
    announcementDescription: 'แพลตฟอร์มสำหรับซื้อขายประกาศ บ้านเช่า/ขายบ้าน ที่ดินขาย/เช่า แบบง่าย',
    companyTitle: 'วิสัยทัศน์และค่านิยมของเรา',
    companyContent: 'ที่ TechMaster Solutions วิสัยทัศน์ของเราคือการเป็นผู้นำระดับโลกด้านนวัตกรรมทางเทคโนโลยี ขับเคลื่อนการเปลี่ยนแปลงเชิงบวกสำหรับธุรกิจทั่วโลก เรามุ่งมั่นสู่ความเป็นเลิศ ความซื่อสัตย์ และความพึงพอใจของลูกค้า ค่านิยมหลักของเราประกอบด้วยนวัตกรรม การทำงานร่วมกัน และการเรียนรู้อย่างต่อเนื่อง เพื่อให้มั่นใจว่าเราจะก้าวล้ำอยู่เสมอในภูมิทัศน์เทคโนโลยีที่เปลี่ยนแปลงอย่างรวดเร็ว',
  },
  my: {
    exchangeRateTitle: 'ငွေလဲနှုန်းစနစ်',
    exchangeRateDescription: 'လုပ်ငန်းများနှင့်ခရီးသွားများအတွက် နောက်ဆုံးရ ငွေလဲနှုန်းနှင့် ပြောင်းလဲမှုကိရိယာ',
    tosTitle: 'Terminal Operations System (TOS)',
    tosDescription: 'စီမံကိန်းရေးဆွဲခြင်း၊ အချိန်ဇယားဆွဲခြင်း၊ အရင်းအမြစ်ခွဲဝေခြင်း၊ အထောက်အထားများ နှင့် ထောက်ပံ့ပို့ဆောင်ရေးဆိုင်ရာ စုစည်းမှုများအတွက် ERP နှင့် ပေါင်းစပ်ထားသော လုပ်ငန်းအလွှာ၊ loading bays များတွင် လုပ်ဆောင်ရန်အတွက် Terminal Operation System (TOS) နှင့် ချိတ်ဆက်ပါ။',
    flightRoutePlanningTitle: 'Flight Route Planning',
    flightRoutePlanningDescription: '3D Maps ဖြင့် လေကြောင်းလမ်းကြောင်းကို စမတ်ကျစွာ စီမံပြီး မိုးလေဝသ ထည့်သွင်းစဉ်းစားကာ လောင်စာသက်သာစေသော ခရီးပိုင်းများ ပြုလုပ်ပါသည်',
    socialSkylineTitle: 'Social Skyline',
    socialSkylineDescription: '3D Maps ပါတဲ့ Social flight game တစ်ခုပါ—မင်းသွားချင်တဲ့နေရာကို လေယာဉ်နဲ့ ပျံသန်းပြီး မိုးကောင်းကင်ပေါ်မှာ မိတ်ဆွေတွေနဲ့ real-time စကားပြောနိုင်ပါတယ်။',
    posSystemTitle: 'POS စနစ်',
    posSystemDescription: 'လက်လီနှင့်စားသောက်ဆိုင်များအတွက် ခေတ်မီ POS စနစ်',
    companyName: 'TechMaster Solutions Co., Ltd.',
    heroTitle: 'Artificial Intelligence',
    heroDescription: 'ကိုယ်တိုင်စိတ်တိုင်းကျ ဖြစ်​စေမယ့် software များကို AI များဖြင့်မြှင့်တင်ပြီး တိကျမှန်ကန်ထိ​ရောက်​အောင်ဝန်​ဆောင်မှု​ပေး​နေပါသည်။ သင့်လုပ်ငန်း၏ လိုအပ်ချက်များနှင့်အံဝန်ခွင်ကျဖြစ်​သော software များကိုရိုးရှင်း​စေရန် AI ဖြင့်​ပေါင်းစပ်ခြင်း တိကျမှန်ကန်ပြီး ​ရေရှည်ထိ​ရောက်​မှုကိုအထူးပြုလုပ်ဝန်​ဆောင်​ပေးပါသည်။',
    readMore: 'ဆက်လက်ဖတ်ရှုရန်',
    about: 'အကြောင်း',
    store: 'စတိုး',
    products: 'ထုတ်ကုန်များ',
    manuals: 'လက်စွဲစာအုပ်များ',
    company: 'ကုမ္ပဏီ',
    signUp: 'စာရင်းသွင်းရန်',
    aboutTitle: 'TechMaster Solutions အကြောင်း',
    aboutContent: 'TechMaster Solutions Co., Ltd. သည် နည်းပညာဆိုင်ရာ ဖြေရှင်းနည်းများကို တီထွင်ဖန်တီးခြင်းနှင့် ယုံကြည်စိတ်ချရသော ဝန်ဆောင်မှုများပေးသော နည်းပညာကုမ္ပဏီတစ်ခုဖြစ်သည်။ 2023 ခုနှစ်တွင် စတင်တည်ထောင်ခဲ့ပြီး လုပ်ငန်းများကို နည်းပညာမြင့်မားသော ဖြေရှင်းနည်းများဖြင့် အားဖြည့်ပေးရန် ရည်ရွယ်ပါသည်။ AI၊ မိုဃ်းတိမ်ဝန်ဆောင်မှုများနှင့် အထူးပြုဆော့ဖ်ဝဲလ်ဖန်တီးမှုများကို အထူးပြုပါသည်။',
    productTitle: 'ကျွန်ုပ်တို့၏ ထူးခြားသော ထုတ်ကုန်များ',
    productContent: 'လုပ်ငန်းလိုအပ်ချက်အမျိုးမျိုးအတွက် အဆင့်မြင့်ထုတ်ကုန်များကို တင်ဆက်ပေးပါသည်။ "CognitoAI" ဟုခေါ်သော AI ပလက်ဖောင်းသည် အလိုအလျောက်လုပ်ငန်းစဉ်များနှင့် ဒေတာခွဲခြမ်းစိတ်ဖြာမှုများကို ပေးစွမ်းပါသည်။ ထို့အပြင် "CloudConnect" သည် လုံခြုံပြီး တိုးချဲ့နိုင်သော မိုဃ်းတိမ်အခြေခံဖွဲ့စည်းမှုဝန်ဆောင်မှုဖြစ်ပြီး "InsightFlow" သည် လုပ်ငန်းသုံး ဒေတာခွဲခြမ်းစိတ်ဖြာမှုကိရိယာတစ်ခုဖြစ်သည်။',
    trackingTitle: 'Recycling System',
    trackingDescription: 'ပြန်လည်အသုံးပြုမှုစနစ် — စုဆောင်းခြင်း၊ ခွဲခြားခြင်း၊ ပြုပြင်ခြင်းနှင့် ရေရှည်တည်တံ့မှုအစီရင်ခံစာများကို တစ်နေရာတည်းတွင် စီမံခန့်ခွဲနိုင်ပါသည်',
    membershipTitle: 'သမဝါယမ စီမံခန့်ခွဲမှုစနစ်',
    membershipDescription: 'သမဝါယမနှင့် အဖွဲ့အစည်းများအတွက် အသင်းဝင်မှတ်တမ်း၊ အကျိုးခံစားခွင့် စီမံခန့်ခွဲမှု၊ ပါဝင်ဆောင်ရွက်မှု ခြေရာခံခြင်းနှင့် အုပ်ချုပ်မှုလုပ်ငန်းစဉ်များကို အပြည့်အစုံ ထောက်ပံ့သော စနစ်',
    aiRecruiterTitle: 'MapRan',
    aiRecruiterDescription: 'ဆိုင်ခွဲများနှင့် အဖွဲ့အစည်းတည်နေရာများကို နိုင်ငံတစ်ဝန်း မြေပုံပေါ်တွင် အခမဲ့ ကြည့်ရှုနိုင်သော MapRan.com ဖြစ်ပြီး ဘာသာစကားအားလုံးကို ထောက်ပံ့ပါသည်',
    announcementTitle: 'ဝယ်/ရောင်း ကြော်ငြာ',
    announcementDescription: 'အိမ်ငှား/ရောင်း၊ မြေယာရောင်း/ငှား ကြော်ငြာများအတွက် ပလက်ဖောင်းတစ်ခု',
    companyTitle: 'ကျွန်ုပ်တို့၏ ရည်မှန်းချက်နှင့် တန်ဖိုးများ',
    companyContent: 'TechMaster Solutions တွင် ကျွန်ုပ်တို့၏ ရည်မှန်းချက်မှာ နည်းပညာတီထွင်မှုအတွက် ကမ္ဘာလုံးဆိုင်ရာ ခေါင်းဆောင်တစ်ဦးဖြစ်ရန်ဖြစ်သည်။ လုပ်ငန်းများအတွက် အကျိုးရှိစေသော အပြောင်းအလဲများကို ဦးဆောင်ပေးရန်၊ ထူးချွန်မှု၊ ရိုးသားမှုနှင့် ဖောက်သည်ကျေနပ်မှုကို အဓိကထားပါသည်။ တီထွင်မှု၊ ပူးပေါင်းဆောင်ရွက်မှုနှင့် ဆက်လက်လေ့လာမှုတို့သည် ကျွန်ုပ်တို့၏ အဓိကတန်ဖိုးများဖြစ်သည်။',
  },
  lo: {
    exchangeRateTitle: 'ລະບົບອັດຕາແລກປ່ຽນ',
    exchangeRateDescription: 'ອັດຕາແລກປ່ຽນເງິນຕາແບບຮັບສະຫຼຸບແລະເຄື່ອງມືແປງຄ່າສໍາລັບທຸລະກິດແລະນັກທ່ອງທ່ຽວ',
    tosTitle: 'ລະບົບປະຕິບັດການຢູ່ປາຍຍອດ (TOS)', 
    tosDescription: 'ເປັນເວທີຊັ້ນທຸລະກິດສໍາລັບການວາງແຜນ, ການກໍານົດເວລາ, ການຈັດສັນຊັບພະຍາກອນ, ຂໍ້ມູນປະຈໍາຕົວ, ແລະການຂົນສົ່ງ orchestration, ປະສົມປະສານກັບ ERP; ການເຊື່ອມຕໍ່ກັບລະບົບປະຕິບັດການ Terminal (TOS) ສໍາລັບການປະຕິບັດຢູ່ໃນການໂຫຼດ.',
    flightRoutePlanningTitle: 'Flight Route Planning',
    flightRoutePlanningDescription: 'ວາງແຜນແລະປັບປຸງເສັ້ນທາງບິນດ້ວຍ 3D Maps ຢ່າງຊາດສະຫຼາດ ພິຈາລະນາສະພາບອາກາດ ແລະຫຼຸດການໃຊ້ນໍ້າມັນໃນແຕ່ລະຊ່ວງບິນ',
    socialSkylineTitle: 'Social Skyline',
    socialSkylineDescription: 'ເກມບິນແບບ Social ພ້ອມ 3D Maps—ບິນໄປໃສກໍໄດ້ຕາມທີ່ຢາກ ແລະຄຸຍກັບໝູ່ໆ ເທິງຟ້າແບບ real-time',
    posSystemTitle: 'ລະບົບ POS',
    posSystemDescription: 'ລະບົບ POS ທັນສະໄໝສໍາລັບຮ້ານຄ້າແລະຮ້ານອາຫານ',
    companyName: 'TechMaster Solutions Co., Ltd.',
    heroTitle: 'ປັນຍາປະດິດ',
    heroDescription: 'ການພັດທະນາແລະປັບແຕ່ງຊອບແວສໍາລັບທຸລະກິດຂອງທ່ານ ພ້ອມຍົກລະດັບປະສິດທິພາບດ້ວຍເທັກໂນໂລຢີ AI ພວກເຮົາຊ່ຽວຊານໃນການສ້າງລະບົບຊອບແວທີ່ຕອບໂຈດທຸລະກິດ ພ້ອມຜະສານ AI ເພື່ອຊ່ວຍໃຫ້ການເຮັດວຽກງ່າຍຂຶ້ນ, ແມ່ນຢ່າງຫຼາຍຂຶ້ນ ແລະຫຼຸດຕົ້ນທຶນໃນລະຍະຍາວ',
    readMore: 'ອ່ານເພີ່ມ',
    about: 'ກ່ຽວກັບ',
    store: 'ຮ້ານ',
    products: 'ສິນຄ້າ',
    manuals: 'ຄູ່ມື',
    company: 'ບໍລິສັດ',
    signUp: 'ລົງທະບຽນ',
    aboutTitle: 'ກ່ຽວກັບ TechMaster Solutions',
    aboutContent: 'TechMaster Solutions Co., Ltd. ແມ່ນບໍລິສັດເທັກໂນໂລຢີຊັ້ນນໍາທີ່ມຸ່ງໝັ້ນໃນການນໍາເສີນການແກ້ໄຂທີ່ເປັນນວັດຕະກຳແລະເຊື່ອຖືໄດ້ ກໍ່ຕັ້ງໃນປີ 2023 ພັນທະກິດຂອງພວກເຮົາແມ່ນການຍົກລະດັບທຸລະກິດດ້ວຍເທັກໂນໂລຢີທີ່ທັນສະໄໝ, ສົ່ງເສີມການເຕີບໂຕແລະປະສິດທິພາບໃນຍຸກດິຈິຕອນ ພວກເຮົາຊ່ຽວຊານດ້ານ AI, ບໍລິການຄລາວດ໌ ແລະການພັດທະນາຊອບແວສໍາລັບທຸລະກິດ',
    productTitle: 'ສິນຄ້ານວັດຕະກຳຂອງພວກເຮົາ',
    productContent: 'ພວກເຮົານໍາເສີນຊຸດສິນຄ້າທີ່ທັນສະໄໝທີ່ອອກແບບມາເພື່ອຕອບໂຈດຄວາມຕ້ອງການທຸລະກິດທີ່ຫຼາກຫຼາຍ "CognitoAI" ແມ່ນແພລດຟອມ AI ທີ່ໃຫ້ການທໍາງານອັດຕະໂນມັດແລະການວິເຄາະຂໍ້ມູນ ນອກຈາກນັ້ນ "CloudConnect" ແມ່ນບໍລິການຄລາວດ໌ທີ່ປອດໄພແລະສາມາດຂະຫຍາຍໄດ້ ແລະ "InsightFlow" ແມ່ນເຄື່ອງມືວິເຄາະທຸລະກິດທີ່ມີປະສິດທິພາບ',
    trackingTitle: 'ລະບົບຣີໄຊເຄິລ',
    trackingDescription: 'ລະບົບບໍລິຫານຣີໄຊເຄິລແບບຄົບວົງຈອນ ຄອບຄຸມການເກັບຮວບຮວມ ຄັດແຍກ ປຸງແຕ່ງ ແລະລາຍງານຄວາມຍືນຍົນ',
    membershipTitle: 'ລະບົບບໍລິຫານສະຫະກອນ',
    membershipDescription: 'ແພລດຟອມບໍລິຫານສະມາຊິກສະຫະກອນ ແລະ ອົງກອນແບບມືອາຊີບ ຄອບຄຸມທະບຽນສະມາຊິກ ການຈັດການສິດປະໂຫຍດ ການຕິດຕາມການມີສ່ວນຮ່ວມ ແລະ ຂັ້ນຕອນການກຳກັບດູແລ',
    aiRecruiterTitle: 'MapRan',
    aiRecruiterDescription: 'ເບິ່ງສາຂາຮ້ານຄ້າ ແລະ ອົງກອນເທິງແຜນທີ່ທົ່ວປະເທດໄດ້ຟຣີຜ່ານ MapRan.com ພ້ອມຮອງຮັບທຸກພາສາ',
    announcementTitle: 'ປະກາດຊື້ຂາຍ',
    announcementDescription: 'ແພລດຟອມສໍາລັບປະກາດຊື້ຂາຍ ບ້ານເຊົ່າ/ຂາຍ ທີ່ດິນຂາຍ/ເຊົ່າ ຢ່າງງ່າຍ',
    companyTitle: 'ວິສັດທັດແລະຄ່ານິຍົມຂອງພວກເຮົາ',
    companyContent: 'ທີ່ TechMaster Solutions ວິສັດທັດຂອງພວກເຮົາແມ່ນການເປັນຜູ້ນໍາລະດັບໂລກດ້ານນວັດຕະກຳເທັກໂນໂລຢີ ນໍາພາການປ່ຽນແປງທີ່ດີສໍາລັບທຸລະກິດທົ່ວໂລກ ພວກເຮົາມຸ່ງຫມັ້ນສູ່ຄວາມເປັນເລີດ, ຄວາມຊື່ສັດ ແລະຄວາມພຶງພໍໃຈຂອງລູກຄ້າ ຄ່ານິຍົມຫຼັກຂອງພວກເຮົາປະກອບດ້ວຍນວັດຕະກຳ, ການຮ່ວມມື ແລະການຮຽນຮູ້ຢ່າງຕໍ່ເນື່ອງ ເພື່ອໃຫ້ແນ່ໃຈວ່າພວກເຮົາຈະຢູ່ນໍາເສີນໃນພູມທັດເທັກໂນໂລຢີທີ່ປ່ຽນແປງຢ່າງວ່ອງໄວ',
  },
};

function App() {
  const languageOrder = ['en', 'th', 'my', 'lo'];
  const [lang, setLang] = useState('en'); // Default language is English
  const t = translations[lang]; // Get current language translations
  const languageOptions = [
    {
      code: 'en',
      label: 'English',
      flag: <GB title="English" style={{ width: 28, height: 20, borderRadius: 4, boxShadow: '0 1px 2px #0001' }} />, 
    },
    {
      code: 'th',
      label: 'ไทย',
      flag: <TH title="ไทย" style={{ width: 28, height: 20, borderRadius: 4, boxShadow: '0 1px 2px #0001' }} />, 
    },
    {
      code: 'my',
      label: 'မြန်မာ',
      flag: <MM title="မြန်မာ" style={{ width: 28, height: 20, borderRadius: 4, boxShadow: '0 1px 2px #0001' }} />, 
    },
    {
      code: 'lo',
      label: 'ລາວ',
      flag: <LA title="ລາວ" style={{ width: 28, height: 20, borderRadius: 4, boxShadow: '0 1px 2px #0001' }} />, 
    },
  ];

  // Create refs for each section
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const productsRef = useRef(null);
  const companyRef = useRef(null);

  // Function to scroll to a specific section
  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 font-sans text-gray-800">
      {/* Tailwind CSS CDN */}
      <script src="https://cdn.tailwindcss.com"></script>
      {/* Font Inter */}
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />

      {/* Header */}
      <header className="sticky top-0 z-20 p-4 md:p-6 lg:p-8 bg-white bg-opacity-90 backdrop-blur-sm shadow-md">
        <nav className="container mx-auto flex items-center justify-between">
          {/* Company Name / Logo - Click to scroll to Hero */}
          <button
            onClick={() => scrollToSection(heroRef)}
            className="flex items-center space-x-3 text-xl md:text-2xl font-bold text-blue-900 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          >
            <img 
              src="/logo192.png" 
              alt="TechMaster Solutions Logo" 
              className="w-8 h-8 md:w-10 md:h-10"
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src = "/logo512.png"; // Fallback to larger logo
              }}
            />
            <span>{t.companyName}</span>
          </button>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <button onClick={() => scrollToSection(aboutRef)} className="text-gray-600 hover:text-blue-700 font-medium transition duration-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">{t.about}</button>
            {/* <button onClick={() => scrollToSection(storeRef)} className="text-gray-600 hover:text-blue-700 font-medium transition duration-300 rounded-md px-3 py-2">{t.store}</button> */}
            <button onClick={() => scrollToSection(productsRef)} className="text-gray-600 hover:text-blue-700 font-medium transition duration-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">{t.products}</button>
            {/* <button onClick={() => scrollToSection(manualsRef)} className="text-gray-600 hover:text-blue-700 font-medium transition duration-300 rounded-md px-3 py-2">{t.manuals}</button> */}
            <button onClick={() => scrollToSection(companyRef)} className="text-gray-600 hover:text-blue-700 font-medium transition duration-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">{t.company}</button>
          </div>

          {/* Language Toggle and Sign Up Button */}
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div className="flex space-x-1">
  {languageOptions.map(opt => (
    <button
      key={opt.code}
      onClick={() => setLang(opt.code)}
      className={`text-2xl px-2 py-1 rounded-full border-2 transition-all duration-150 ${lang === opt.code ? 'border-blue-600 bg-blue-100' : 'border-transparent hover:border-blue-300'}`}
      aria-label={opt.label}
      style={{ background: lang === opt.code ? '#DBEAFE' : 'transparent' }}
    >
      {opt.flag}
    </button>
  ))}
</div>
            </div>
            {/*<a href="#" className="hidden md:block px-6 py-2 bg-indigo-600 text-white font-semibold rounded-full shadow-lg hover:bg-indigo-700 transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50">
              {t.signUp}
            </a>*/}
          </div>

          {/* Mobile Menu Button (for small screens) - Placeholder for future implementation */}
          <div className="md:hidden">
            <button className="text-gray-600 hover:text-blue-700 focus:outline-none">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </nav>
      </header>

      {/* Main Content Area */}
      <main className="relative overflow-hidden">
        {/* Hero Section */}
        <section ref={heroRef} className="relative flex items-center justify-center min-h-0 py-2 md:py-4 lg:py-6 overflow-hidden">
          {/* Background elements to mimic the image's aesthetic */}
          <div className="absolute inset-0 z-0 opacity-20">
            {/* Subtle globe pattern (simplified) */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-blue-300 animate-pulse-slow"></div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-blue-200 animate-pulse-slow delay-1000"></div>
          </div>

          {/* Content Area */}
          <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center justify-between relative z-10">
            {/* Text Content */}
            <div className="lg:w-1/2 text-center lg:text-left mb-12 lg:mb-0">
              <h1 className="text-4xl md:text-6xl font-extrabold leading-tight text-gray-900 mb-2 drop-shadow-lg">
                {t.heroTitle}
              </h1>
              <p className="text-lg md:text-xl text-gray-600 mb-2 max-w-xl mx-auto lg:mx-0">
                {t.heroDescription}
              </p>
            </div>

            {/* Image Section */}
            <div className="lg:w-1/2 flex justify-center items-center relative">
              <div className="relative w-full max-w-md h-80 md:h-96 rounded-3xl shadow-2xl flex items-center justify-center overflow-hidden">
                <img
                  src={aiHand}
                  alt="AI and Human Hand Interacting"
                  className="object-cover w-full h-full rounded-3xl"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop
                    e.target.src = "https://placehold.co/400x320/E0E7FF/4338CA?text=Image+Not+Found"; // Placeholder image
                  }}
                />
              </div>
            </div>

          </div>
        </section>

        {/* About Section */}
        <section ref={aboutRef} id="about" className="py-16 md:py-24 bg-white shadow-inner">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-8">
              {t.aboutTitle}
            </h2>
            <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              {t.aboutContent}
            </p>
          </div>
        </section>


        {/* Company Section */}
        <section ref={companyRef} id="company" className="py-16 md:py-24 bg-white shadow-inner">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-8">
              {t.companyTitle}
            </h2>
            <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              {t.companyContent}
            </p>
            {/* You can add team photos, mission statements here later */}
          </div>
        </section>

        {/* Product Section (custom as per user request) */}
        <section ref={productsRef} id="products" className="py-16 md:py-24 bg-blue-50">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-12">
              {t.products}
            </h2>
            <div className="flex flex-col gap-8 max-w-7xl mx-auto">
              {/* First row: 3 products */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {/* TOS Product */}
                <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    {/* Terminal/server SVG icon */}
                    <svg className="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <rect x="3" y="4" width="18" height="14" rx="2" strokeWidth="2" stroke="currentColor" fill="none" />
                      <path d="M8 10h.01M12 10h4" strokeWidth="2" stroke="currentColor" fill="none" />
                      <path d="M8 14h8" strokeWidth="2" stroke="currentColor" fill="none" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.tosTitle}</h3>
                  <p className="text-gray-600">{t.tosDescription}</p>
                </div>
                {/* Exchange Rate System Product */}
                <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8V4m0 0L8 8m4-4l4 4M12 16v4m0 0l4-4m-4 4l-4-4M4 12h16" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.exchangeRateTitle}</h3>
                  <p className="text-gray-600">{t.exchangeRateDescription}</p>
                </div>
                {/* Recycling System Product */}
                <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m-6 3l6-3"></path>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.trackingTitle}</h3>
                  <p className="text-gray-600">{t.trackingDescription}</p>
                </div>
                {/* Membership Product */}
                <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.membershipTitle}</h3>
                  <p className="text-gray-600">{t.membershipDescription}</p>
                </div>
              </div>
              {/* Second row: 4 products */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {/* MapRan Product */}
                <a
                  href="https://MapRan.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m-6 3l6-3" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.aiRecruiterTitle}</h3>
                  <p className="text-gray-600">{t.aiRecruiterDescription}</p>
                  <p className="mt-4 text-sm font-semibold text-blue-600 hover:underline">MapRan.com</p>
                </a>
                {/* Buying and Selling Announcement Product */}
                <div className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.announcementTitle}</h3>
                  <p className="text-gray-600">{t.announcementDescription}</p>
                </div>
                {/* Social Skyline Product */}
                <a
                  href="https://gadnad.online/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 11h10M7 15h6" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 15a4 4 0 01-4 4H7l-4 3V7a4 4 0 014-4h10a4 4 0 014 4v8z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.socialSkylineTitle}</h3>
                  <p className="text-gray-600">{t.socialSkylineDescription}</p>
                  <p className="mt-4 text-sm font-semibold text-blue-600 hover:underline">gadnad.online</p>
                </a>
                {/* Flight Route Planning Product */}
                <a
                  href="https://gadnad.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2"
                >
                  <div className="w-16 h-16 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">{t.flightRoutePlanningTitle}</h3>
                  <p className="text-gray-600">{t.flightRoutePlanningDescription}</p>
                  <p className="mt-4 text-sm font-semibold text-blue-600 hover:underline">gadnad.com</p>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Simple Footer (optional) */}
      <footer className="pt-12 pb-4 bg-gray-100 mt-8 border-t border-gray-200">
        <div className="container mx-auto px-4 flex flex-col md:flex-row md:justify-between md:items-start gap-8">
          {/* Company Section */}
          <div className="md:w-1/2">
            <h3 className="text-lg font-semibold text-blue-900 mb-3">Company</h3>
            <ul className="space-y-2 text-gray-700">
              <li><span className="font-medium">Address:</span> 113 M.7 Sanphranet, Sansai, Chiang Mai 50210</li>
              <li><span className="font-medium">Phone:</span> 064-9960066</li>
              <li><span className="font-medium">Line:</span> 📱 @293jngns</li>
              <li><span className="font-medium">Email:</span> info@techmastersolutions.co.th</li>
              <li><span className="font-medium">Facebook:</span> <a href="https://www.facebook.com/people/TechMaster-Solutions-Co-Ltd/61557877112377/" className="text-blue-600 hover:underline">facebook.com/techmastersolutions-co-ltd</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} {t.companyName}. All rights reserved.
        </div>
      </footer>

      <style>{`
        body {
          font-family: 'Inter', sans-serif;
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s infinite ease-in-out;
        }
        @keyframes pulse-slow {
          0%, 100% {
            transform: scale(0.95);
            opacity: 0.2;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.3;
          }
        }
      `}</style>
    </div>
  );
}

export default App;
